import * as actionTypes from "../../constants";

const initialState = {
  data: null,
  error: {},
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DO_GET_PURCHASED_PRODUCT_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};

export default menuReducer;
